export default __webpack_public_path__ + "static/media/device_marker_1.5e68b894.svg";